import { isAxiosError } from "axios";
import { z } from "zod";
import { pluralize } from "@common/helpers/string";

export const UNKNOWN_RULE_SAVE_ERROR = "Unknown error";

const RuleSaveErrorBodySchema = z.object({
    message: z.union([z.string(), z.array(z.string())]).optional(),
    bodyResult: z
        .object({ issues: z.array(z.object({ message: z.string() })) })
        .optional(),
});

export function getRuleSaveErrorMessage(error: Error): string {
    if (!isAxiosError(error)) {
        return error.message || UNKNOWN_RULE_SAVE_ERROR;
    }
    const parsed = RuleSaveErrorBodySchema.safeParse(error.response?.data);
    if (!parsed.success) {
        return UNKNOWN_RULE_SAVE_ERROR;
    }
    const { message, bodyResult } = parsed.data;
    if (message) {
        return Array.isArray(message) ? message.join("; ") : message;
    }
    if (bodyResult) {
        const issueMessages = bodyResult.issues.map((issue) => issue.message);
        return issueMessages.length > 0
            ? issueMessages.join("; ")
            : "Invalid rule payload";
    }
    return UNKNOWN_RULE_SAVE_ERROR;
}

export function buildRuleSaveFailureMessage(messages: string[]): string {
    if (messages.length === 1) {
        return `Rule not created: ${messages[0]}`;
    }
    const uniqueMessages = [...new Set(messages)];
    return `${messages.length} ${pluralize("rule", messages.length)} not created: ${uniqueMessages.join("; ")}`;
}
